import { Outlet, Navigate } from "react-router-dom";
import useAuthStore from "../store/authStore";

const AdminRouteProtect = () => {
  const { refToken, isAuthenticated, userType } = useAuthStore();

  return refToken && isAuthenticated && userType === "admin" ? (
    <Outlet />
  ) : (
    <Navigate to={"/login"} />
  );
};
export default AdminRouteProtect;
